import theme from '../../theme'
import React from 'react'
import { TextLink } from '../Links'
import styled from 'styled-components'
import gtmEvent from '../../../utils/gtm'

export const links = [
  {
    title: 'Why ADM?',
    url: '#get-started',
    icon: ''
  },
  {
    title: 'Features',
    url: '#app',
    icon: ''
  },
  {
    title: 'Download',
    url: '#download',
    icon: ''
  },
  {
    title: 'Find a Coach',
    url: 'https://pga.com/coach',
    icon: ''
  }
]

export const linksMobile = [
  {
    title: 'PGA Coach Tools',
    url: 'https://my.pga.com/pga-coach',
    icon: ''
  },
  {
    title: 'PGA Coach Training',
    url: 'https://pgacoach.lightspeedvt.com',
    icon: ''
  },
  {
    title: 'LPGA Member Training',
    url: 'https://pgaguest.lightspeedvt.com',
    icon: ''
  },
  {
    title: 'Industry Guest Training',
    url: 'https://pgaguest.lightspeedvt.com',
    icon: ''
  },
  {
    title: 'High School Coach Training',
    url: 'https://pgaguest.lightspeedvt.com',
    icon: ''
  }
]
// PGA Members becomes PGA Coach Tools - my.pga.com/pga-coach
// Add PGA Coach Training - pgacoach.lightspeedvt.com
// LPGA Members becomes LPGA Member Training - pgaguest.lightspeedvt.com
// Industry Guests becomes Industry Guest Training - pgaguest.lightspeedvt.com
// High School Coaches becomes High School Coach Training - pgaguest.lightspeedvt.com
export const CustomTextLink = styled(TextLink)`
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.05em;
`

export const handleSignInClick = title => {
  gtmEvent({
    event: 'sign-in-click',
    signinCategory: 'sign-in',
    signinLabel: 'sign-in',
    signinAction: `click - ${title}`
  })
}

export const LinksContainer = ({
  links = [],
  padding,
  color,
  handleLinkClick = () => {}
}) => (
  <>
    {links.map(({ url, title, icon }) => (
      <CustomTextLink
        url={url}
        key={title}
        color={color}
        hoverColor={theme.colors.gray}
        padding={padding}
        transform='uppercase'
        aria-label={title}
        onClick={() => handleLinkClick(title)}
      >
        {title}
      </CustomTextLink>
    ))}
  </>
)
